<template>
  <van-overlay :show="showDetail" z-index="1000" :lock-scroll="true">
    <div class="sign-wrap">
      <div class="sign-content">
        <div class="sign-close" @click="close"></div>
        <div class="sign-item" v-for="item in childProperties" :key="item.label">
          <div class="sign-item-label">{{ item.label }}</div>
          <div class="sign-item-value">{{ personInfo[item.value] }}</div>
        </div>
        <img class="sign-bg" src="~paintingCompetition/assets/matchGuide/information_bg.png" alt="" />
        <img
          class="sign-btn"
          src="~paintingCompetition/assets/matchGuide/information_confirm.png"
          alt=""
          @click="confirmSignUp"
        />
      </div>
    </div>
  </van-overlay>
</template>

<script>
import { transferRegistration } from '../../api/index'
import { mapState } from 'vuex'

export default {
  data() {
    return {
      showDetail: false,
      personInfo: {},
      childProperties: [
        {
          label: '孩子昵称',
          value: 'nickName'
        },
        {
          label: '孩子出生年月',
          value: 'birthday'
        },
        {
          label: '联系手机',
          value: 'account'
        },
        {
          label: '所在地区',
          value: 'area'
        }
      ]
    }
  },
  computed: {
    ...mapState(['uukey'])
  },
  methods: {
    show(form) {
      console.log('form', form)
      this.personInfo = form
      this.showDetail = true
      this.recordLog({
        eventName: 'PaintChina_experience_pop',
        properties: {
          eventId: '体验课信息确认弹窗',
          label: '体验课信息确认弹窗'
        }
      })
    },
    confirmSignUp() {
      this.$toast.loading({
        message: '报名中',
        forbidClick: true,
        overlay: true
      })
      transferRegistration(this.uukey || window.sessionStorage.getItem('uukey')).then(res => {
        this.$toast.clear()
        if (res.code === 0) {
          this.$toast('报名成功！')
          this.$emit('successSignup')
        } else {
          this.$toast('报名失败！')
        }
        setTimeout(() => {
          this.close()
        }, 1000)
      })
    },
    close() {
      this.showDetail = false
    }
  }
}
</script>

<style lang="scss" scoped>
.sign-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .sign-content {
    position: relative;
    width: 554px;
    height: 519px;
    padding: 53px 70px;
    background: #fefefe;
    border-radius: 30px;
    box-sizing: border-box;
  }
  .sign-item {
    display: flex;
    align-items: center;
    padding: 20px 0 20px 10px;
    border-bottom: 1px solid #e6e6e6;
    .sign-item-label {
      width: 200px;
      font-size: 30px;
      color: #959595;
    }
    .sign-item-value {
      font-size: 30px;
      color: #333333;
      max-width: 200px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  .sign-bg {
    position: absolute;
    bottom: 44px;
    left: -35px;
    width: 624px;
    height: 358px;
  }
  .sign-btn {
    position: absolute;
    width: 365px;
    height: 129px;
    bottom: -55px;
    left: 100px;
  }
  .sign-close {
    position: absolute;
    top: -85px;
    right: -24px;
    width: 56px;
    height: 56px;
    background: url('~paintingCompetition/assets/common/close.png') no-repeat;
    background-size: 100% auto;
  }
}
</style>
